<script>
import {
  DeleteOutlined,
  DownOutlined,
  EditOutlined,
  PlusCircleOutlined,
  UpOutlined,
} from '@ant-design/icons-vue';
import bem from '@/utils/bem';
import { mapActions } from 'vuex';

const b = bem('know-about');

export default {
  name: 'KnowAbout',
  components: {
    PlusCircleOutlined,
    UpOutlined,
    DeleteOutlined,
    EditOutlined,
    DownOutlined,
  },
  props: {
    isMobile: Boolean,
    faq: Object,
    faqs: {
      type: Array,
      default: () => [],
    },
    index: Number,
    editFAQ: Function,
    isShowActionsForFAQ: Boolean,
    isSecondChildren: Boolean,
  },
  data() {
    return {
      isShowContent: false,
    };
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      editFAQOrderIndexAction: 'faq/editFAQOrderIndexAction',
      deleteFAQAction: 'faq/deleteFAQAction',
      editFAQAction: 'faq/editFAQ',
    }),
    handleShowContent() {
      this.isShowContent = !this.isShowContent;
    },
    handleIsCategory() {
      const {
        id,
        page,
        isCategory,
        parentId,
        faqs,
        order,
        ...body
      } = this.faq;
      this.editFAQAction({
        body: {
          ...body,
          isCategory: !isCategory,
        },
        id,
        path: page,
      });
    },
    onDeleteFAQ() {
      this.deleteFAQAction({
        id: this.faq.id,
        path: this.faq.page,
      });
    },
    editFAQOrderIndex(method) {
      switch (method) {
        case 'up': {
          return this.editFAQOrderIndexAction({
            path: this.faq.page,
            body: [
              { id: this.faq.id, order: this.faqs[this.index - 1].order },
              { id: this.faqs[this.index - 1].id, order: this.faq.order },
            ],
          });
        }
        case 'down': {
          return this.editFAQOrderIndexAction({
            path: this.faq.page,
            body: [
              { id: this.faq.id, order: this.faqs[this.index + 1].order },
              { id: this.faqs[this.index + 1].id, order: this.faq.order },
            ],
          });
        }
        default: {
          return null;
        }
      }
    },
  },
  computed: {
    description() {
      const description = this.isMobile
        ? this.faq.descriptionMobile || this.faq.description
        : this.faq.description;
      return description.split('[[').reduce((acc, item) => {
        const [substring, continueText] = item.split(']]');
        const [link, linkText] = substring.split('|');
        return `${acc}<a href=${link} target="_blank">${linkText}</a>${continueText}`;
      });
    },
  },
};
</script>

<template>
  <div
    :class="b('', {isMobile})"
  >
    <div :class="b('faq-item-wrapper', { isCategory: faq.isCategory })">
      <div
        :class="b('faq-item-title-wrapper', {isMobile})"
      >
        <span :class="b('faq-item-title', {isMobile, isCategory: faq.isCategory})">
          {{isMobile
            ? faq.titleMobile || faq.title
            : faq.title
          }}
        </span>
        <a-button
          type="text"
          @click="handleShowContent"
          v-if="!isShowActionsForFAQ"
        >
          <DownOutlined
            fill="#5F8AA4"
            :class="b('icon')"
          />
        </a-button>
        <div
          v-else
          :class="b('actions-wrapper', {isMobile})"
        >
          <div
            :class="b('actions')"
            v-if="!isSecondChildren"
          >
            <div :class="b('switch-wrapper', {isMobile})">
              Category:
              <a-switch
                :class="b('switcher')"
                @click="handleIsCategory"
                :checked="faq.isCategory"
                checked-children="Yes"
                un-checked-children="No"
              />
            </div>
          </div>
          <div :class="b('actions')">
            <a-button
              v-if="index !== 0"
              :class="b('action-button')"
              type="primary"
              html-type="button"
              @click="() => editFAQOrderIndex('up')"
            >
              <template #icon>
                <UpOutlined />
              </template>
            </a-button>
            <a-button
              v-if="index !== faqs.length - 1"
              :class="b('action-button')"
              type="primary"
              html-type="button"
              @click="() => editFAQOrderIndex('down')"
            >
              <template #icon>
                <DownOutlined />
              </template>
            </a-button>
          </div>
          <div :class="b('actions')">
            <a-button
              class="action-button"
              type="primary"
              html-type="button"
              @click="() => editFAQ({changeableFAQ: faq})"
            >
              <EditOutlined /> Edit
            </a-button>
            <a-popconfirm title="Sure to delete?" @confirm="onDeleteFAQ()">
              <a-button
                type="primary"
                html-type="button"
                danger
                class="action-button"
              >
                <DeleteOutlined /> Delete
              </a-button>
            </a-popconfirm>
          </div>
        </div>
      </div>
    </div>
    <div
      :class="b('faq-item-description', {isMobile})"
      v-if="isShowContent && !isShowActionsForFAQ && !faq.isCategory"
      v-html="description"
    ></div>
    <div
      :class="b('faq-list', {isMobile})"
      v-if="(isShowContent || isShowActionsForFAQ) && faq.isCategory"
    >
      <KnowAbout
        v-for="(childrenFaq, index) in (faq?.faqs || [])"
        :is-mobile="isMobile"
        :faq="childrenFaq"
        :key="'faq-' + childrenFaq.id"
        :faqs="(faq?.faqs || [])"
        :index="index"
        :editFAQ="({changeableFAQ}) => editFAQ({
          changeableFAQ,
          parentFAQ: faq
        })"
        :isShowActionsForFAQ="isShowActionsForFAQ"
        isSecondChildren
      />
      <a-button
        @click="() => editFAQ({parentFAQ: faq})"
        :class="b('plus-btn', {isMobile})"
      >
        Add FAQ <PlusCircleOutlined :class="b('plus')" />
      </a-button>
    </div>
  </div>
</template>

<style src="./style.scss" lang="scss" scoped></style>
